export default {
  deviceRegistrations: [],
  filter: {
    includeLoader: false,
    includeTransporter: false
  }
}
